// IMPACT Head-Shim (Home only) – verhindert TypeError in ProductRerender
// Läuft bewusst VOR theme.js (wichtig!)
(function () {
  // Nur auf der Startseite (optional Sprachpräfixe wie /de, /en)
  var p = location.pathname.replace(/^\/(de|en)(?=\/|$)/, '');
  var isHome = (p === '/' || p === '');

  if (!isHome) return;

  // Sorgt dafür, dass document.forms[observe-form] nie undefined ist
  function ensureObservedForms(root) {
    var scope = root || document;
    var nodes = scope.querySelectorAll('[observe-form]');
    nodes.forEach(function (el) {
      var name = el.getAttribute('observe-form');
      if (!name) return;
      if (!document.forms[name]) {
        var f = document.createElement('form');
        f.setAttribute('name', name);
        f.setAttribute('aria-hidden', 'true');
        f.style.display = 'none';
        // sehr früh einhängen, damit document.forms[...] sofort greift
        document.documentElement.appendChild(f);
      }
    });
  }

  // Patch für <product-rerender>, um fehlendes Form abzufangen
  function hardenProductRerender() {
    if (!window.customElements) return;

    function patch(Ctor) {
      if (!Ctor) return;
      var proto = Ctor.prototype;
      if (proto.__patched_product_rerender) return;

      var orig = proto.connectedCallback;
      proto.connectedCallback = function () {
        try {
          var n = this.getAttribute('observe-form');
          if (n && !document.forms[n]) {
            var f = document.createElement('form');
            f.setAttribute('name', n);
            f.setAttribute('aria-hidden', 'true');
            f.style.display = 'none';
            document.documentElement.appendChild(f);
          }
        } catch (e) {
          // ignore
        }
        try {
          return orig && orig.apply(this, arguments);
        } catch (e) {
          var msg = (e && e.message) ? String(e.message) : '';
          // Nur den bekannten Fall dämpfen
          if (msg.includes("reading 'addEventListener'")) { return; }
          throw e;
        }
      };

      proto.__patched_product_rerender = true;
    }

    var C = customElements.get && customElements.get('product-rerender');
    if (C) { patch(C); }
    else if (customElements.whenDefined) {
      customElements.whenDefined('product-rerender').then(function () {
        patch(customElements.get('product-rerender'));
      });
    }
  }

  // so früh wie möglich
  try { ensureObservedForms(document); } catch (e) {}
  try { hardenProductRerender(); } catch (e) {}

  // Falls Sections später ins DOM kommen, kurz nachfassen – sehr sparsam
  document.addEventListener('DOMContentLoaded', function () {
    try { ensureObservedForms(document); } catch (e) {}
    // winziger Observer nur kurz aktiv
    try {
      var mo = new MutationObserver(function (muts) {
        for (var i=0;i<muts.length;i++){
          var m = muts[i];
          if (m.addedNodes && m.addedNodes.length) {
            ensureObservedForms(document);
            break;
          }
        }
      });
      mo.observe(document.documentElement, { childList: true, subtree: true });
      setTimeout(function(){ try { mo.disconnect(); } catch(e){} }, 1500);
    } catch (e) {}
  }, { once: true });
})();